import { useUserStore } from '@app/stores';
export const usePermissionsGuard = (permissions) => {
    const [user] = useUserStore();
    return permissions === null || permissions === void 0 ? void 0 : permissions.every((permission) => { var _a; return (_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a.includes(permission); });
};
